<template>
  <section class="">
    <div class="mb-2 px-6">
      <h4 class="text-base font-medium capitalize">Recent</h4>
    </div>
    <ul class="space-y-1 divide-y px-6">
      <ResultItem
        v-for="(item, index) in _history"
        :key="getItemKey(item, index)"
        :item="item"
        :category="item.type"
        :highlighted="highlightedIndex === findHighlightedIndex(item)"
        density="compact"
        @mouseover="emit('mouseover', findHighlightedIndex(item))"
        @click="emit('click')"
      />
    </ul>
  </section>
</template>

<script setup lang="ts">
import { nanoid } from 'nanoid';
import { computed } from 'vue';

import type { Results } from '@/entities/search';

import ResultItem from '../result-item.vue';

const emit = defineEmits(['click', 'mouseover']);

const props = defineProps<{
  history: Results[];
  highlightedIndex: number;
}>();

const findHighlightedIndex = (item: Results & { _uuid?: string }) => {
  return _history.value.findIndex((_item) => _item._uuid === item._uuid);
};

const _history = computed(() => props.history.map((item) => ({ ...item, _uuid: nanoid() })));

const getItemKey = (item: Results, index: number) => {
  if ('id' in item) return `id-${item.id}`;
  if ('uuid' in item) return `uuid-${item.uuid}`;
  if ('name' in item) return `name-${item.name}`;
  return `index-${index}`;
};
</script>
